// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__37F5d","type":"styles_type__2-KZj","choices":"styles_choices__VPYA-"};